import { useState } from 'react';
import { FiEye, FiEyeOff } from 'react-icons/fi';

const PasswordInput = ({ id, placeholder, className, register, autoComplete }) => {
  const [showPassword, setShowPassword] = useState(false);
  const inputType = showPassword ? 'text' : 'password';

  return (
    <>
      <input
        id={id}
        type={inputType}
        placeholder={placeholder}
        {...register(id)}
        className={className}
        autoComplete={autoComplete}
      />
      <button
        type="button"
        onClick={() => setShowPassword(!showPassword)}
        aria-label={showPassword ? 'Hide password' : 'Show password'}
        aria-pressed
        className="password-toggle-button">
        {showPassword ? <FiEye size={18} /> : <FiEyeOff size={18} />}
      </button>
    </>
  );
};

export default PasswordInput;
